<template>
  <v-card>
    <v-card-title class="headline"
      >Filtros
      <v-btn
        style="right: 10px; top: 10px"
        icon
        color="primary"
        fab
        absolute
        @click="$emit('cancel')"
      >
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-select
              :items=" tab == '1' ? status : payLinksStatus"
              filled
              clearable
              v-model="selectedStatus"
              label="Seleccionar estado"
              rounded
              multiple
              chips
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value="date"
              persistent
              width="350"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date"
                  label="Filtrar por fecha"
                  readonly
                  filled
                  rounded
                  hide-details
                  :disabled="loading"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                range
                :title-date-format="title"
                scrollable
                :max="today"
              >
                <v-row no-gutters style="flex-wrap: nowrap">
                  <v-btn
                    class="flex-grow-1 flex-shrink-0"
                    large
                    rounded
                    outlined
                    color="primary"
                    @click="modal = false"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    class="flex-grow-1 flex-shrink-0"
                    large
                    rounded
                    color="primary"
                    @click="$refs.dialog.save(date)"
                  >
                    Aceptar
                  </v-btn>
                </v-row>
              </v-date-picker>
            </v-dialog>
          </v-col>

          <v-col cols="12" sm="12" md="12" class="mb-2 pb-0 mt-3">
            <v-btn
              rounded
              @click="success"
              filled
              block
              height="50"
              color="primary"
            >
              Aplicar filtros
            </v-btn></v-col
          >
        </v-row>
      </v-container>
    </v-card-text>

    <!-- <v-card-actions style="justify-content: center">
      <v-btn
        color="red darken-4"
        dark
        class="mb-3"
        width="95%"
        rounded
        :min-height="48"
        :loading="loading"
        @click="$emit('confirm')"
      >
        Eliminar
      </v-btn>
    </v-card-actions> -->
  </v-card>
</template>

<script>
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");

export default {
  name: "filters",
  props: ["originalStatus", "originalDate", "tab"],
  data() {
    return {
      loading: false,
      modal: false,
      selectedStatus: [],
      status: [
        { value: "placed", text: "Colocada" },
        { value: "accepted", text: "Aceptada" },
        { value: "enRoute", text: "Chavo en Camino al Comercio" },
        { value: "onDelivery", text: "Chavo en Camino al Cliente" },
        { value: "delivered", text: "Entregada al Cliente" },
        { value: "completed", text: "Orden Completada" },
        { value: "canceled", text: "Cancelada por Dilo" },
        { value: "pendingValidation", text: "Requiere Validación" },
        { value: "rejected", text: "Rechazada por el Negocio" },
      ],
      payLinksStatus : [
        { value: "paid", text: "Pagado" },
        { value: "pending", text: "Pendiente" },
        { value: "canceled", text: "Cancelado" },
        { value: "expired", text: "Expiró" },
      ],
      date: [
        `${moment()
          .tz("America/Tegucigalpa")
          .subtract(6, "hours")
          .toISOString()
          .substr(0, 10)}`,
        `${moment()
          .tz("America/Tegucigalpa")
          .subtract(6, "hours")
          .toISOString()
          .substr(0, 10)}`,
      ],
    };
  },
  computed: {
    today() {
      return new Date().toISOString().substr(0, 10);
    },
  },

  methods: {
    title() {
      return "Selecciona un rango de fechas";
    },

    success() {
      this.$emit("success", {
        date: this.date,
        selectedStatus: this.selectedStatus,
      });
    },
  },

  mounted() {
    if (this.originalDate) {
      this.date = this.originalDate;
    }

    if (this.originalStatus) {
      this.selectedStatus = this.originalStatus;
    }
  },
};
</script>